import { Outlet, useNavigate } from "react-router-dom";
import { useAuthStore } from "../stores/authStore";

function AuthLayout() {
  const { auth } = useAuthStore();
  const navigate = useNavigate();

  if (!auth.accessToken) {
    auth.reset();
    navigate("/sign-in");
    return;
  }
  return <Outlet />;
}

export default AuthLayout;
